import {NgForOf} from '@angular/common';
import {Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {PAGES_AND_PATHS} from 'src/app/constants/pages-and-paths';
import {LystTypeFilter} from 'src/app/enums/list-enums';
import {TlPagination} from 'src/app/interfaces/general-interfaces';
import {List, ListItem} from 'src/app/services/http-services/lists/lists-http-intterfaces';
import {ListsHttpService} from 'src/app/services/http-services/lists/lists-http.service';
import {MatchLocaleModule} from '../../../../../pipes/match-locale/match-locale.module';

@Component({
  selector: 'app-copy-item-modal',
  standalone: true,
  imports: [NgForOf, TranslateModule, MatchLocaleModule],
  templateUrl: './copy-item-modal.component.html',
})
export class CopyItemModalComponent implements OnInit {
  @Input() selectedItem: ListItem | null = null;
  @Input() url = '';
  @Output() closeModal = new EventEmitter<boolean>();
  lists: List[] = [];
  pageNum = 1;
  pagination!: TlPagination;
  activeListType: LystTypeFilter = LystTypeFilter.allLysts;
  selectedList: List | null = null;
  PAGES_AND_PATHS = PAGES_AND_PATHS;
  @Output() isOpenToastOpen = new EventEmitter<boolean>();
  @Output() selectedListAndItem = new EventEmitter<{ item: any, list: any }>();
  @ViewChild('listContainer', {static: false}) private listContainer!: ElementRef;
  loading = false;

  constructor(
    private listsHttpService: ListsHttpService,
    private toastService: ToastrService,
    private router: Router
  ) {
  }

  ngOnInit(): void {
    this.getMyLystsV2(this.pageNum, this.activeListType);
  }

  getMyLystsV2(pageNumber: number, filter: LystTypeFilter): Promise<any> {
    this.loading = true;
    return new Promise((resolve, reject) => {
      this.listsHttpService.getMyLystsV2(pageNumber, filter).then((res: any) => {
        try {
          this.lists = [...this.lists, ...res.data];
          this.pagination = res.pagination;
          this.loading = false;
        } catch (e) {
          this.loading = false;
        }
        this.pagination = res.pagination;
        resolve(res);
      }, error => {
        this.loading = false;
        reject(false);
      })
    });
  }

  select(list: List): void {
    this.selectedList = list;
  }

  addItemToList(): void {
    if (this.selectedList !== null && this.selectedItem !== null) {
      this.listsHttpService.copyListItem(this.selectedList?.id, this.selectedItem?.id).subscribe((response: any) => {
        this.isOpenToastOpen.emit(true);
        this.selectedListAndItem.emit({list: this.selectedList, item: this.selectedItem});
        this.closeModal.emit(true);
      })
    }
  }

  createNewList(): void {
    const pageDetails = {
      selectedItem: this.selectedItem,
      url: this.url
    }
    this.router.navigate([PAGES_AND_PATHS.createList.pagePath], {state: pageDetails});
  }

  onScroll(): void {
    const container = this.listContainer.nativeElement;
    const scrollTop = container.scrollTop;
    const scrollHeight = container.scrollHeight;
    const clientHeight = container.clientHeight;

    const isAtBottom = scrollTop + clientHeight >= scrollHeight - 100;

    if (!this.loading && isAtBottom && ((this.pagination?.currentPage ?? 0) < (this.pagination?.lastPage ?? 0))) {
      this.pageNum++;
      this.getMyLystsV2(this.pageNum, this.activeListType);
    }
  }

}
